var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgActionSettings18 = function SvgActionSettings18(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 9.093a6.083 6.083 0 010-.186L1.55 7.271a1 1 0 01-.118-1.163l1.28-2.216a1 1 0 011.066-.48l2.14.439a3.81 3.81 0 01.163-.094l.691-2.073A1 1 0 017.721 1h2.558a1 1 0 01.949.684l.69 2.073c.056.03.11.061.163.094l2.141-.439a1 1 0 011.067.48l1.279 2.216a1 1 0 01-.118 1.163L15 8.907a5.72 5.72 0 010 .186l1.45 1.636a1 1 0 01.118 1.163l-1.28 2.216a1 1 0 01-1.066.48l-2.14-.438a6.215 6.215 0 01-.163.093l-.691 2.073a1 1 0 01-.949.684H7.721a1 1 0 01-.949-.684l-.69-2.073a6.105 6.105 0 01-.163-.094l-2.141.439a1 1 0 01-1.067-.48l-1.279-2.216a1 1 0 01.118-1.163L3 9.093zM9 12a3 3 0 100-6 3 3 0 000 6z",
    clipRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActionSettings18, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "880b22a72d1154f1d0a5d710ea09eae6.svg";
export { ForwardRef as ReactComponent };